<template>
  <div class="footer flex-container center">
    <div class="footer-content flex-container center">
      \
      <v-spacer />
      <a href="/" class="footer-logo" />
      <v-spacer />
      <div class="text-2 thin color-lightgrey opaque">
        T. 044-865-6038 | E. contact@damons.kr |
        <b>(주)데이터몬스터즈</b> |
        <b>세종특별자치시 나성로 96 어반아트리움 더센트럴 601, 611호</b>
        <br />Copyrights Data Monsters Inc. - All Rights Reserved
      </div>
      <v-spacer />
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style>
.footer {
  width: 100%;
  height: 100px;
  background: url("../assets/footerbg.jpg") no-repeat center;
}

.footer-content {
  width: 1000px;
}

.footer-logo {
  height: 25px;
  width: 55px;
  background: url("../assets/footlogo.png") no-repeat center;
  background-size: contain;
}

@media only screen and (max-width: 880px) {
  .footer {
    visibility: hidden;
  }
}
</style>
